import * as Yup from 'yup';

const requiredWhenToast = (message: string) =>
    Yup.string().when('posProvider', {
        is: 'TOAST',
        then: schema => schema.required(message),
        otherwise: schema => schema.notRequired()
    });

const toastDictionarySchema = Yup.array().when('posProvider', {
    is: 'TOAST',
    then: () =>
        Yup.array().of(
            Yup.object({
                key: Yup.string().required('Scenario is required'),
                value: Yup.string().required('GUID is required')
            })
        ),
    otherwise: schema => schema
});

export const toastGlobalValidationSchema = Yup.object({
    toastHost: requiredWhenToast('Host is required'),
    toastClientId: requiredWhenToast('Client ID is required'),
    toastClientSecret: requiredWhenToast('Client Secret is required')
});

export const toastLocationValidationSchema = Yup.object({
    toastRestaurantGuid: requiredWhenToast('Restaurant GUID is required'),
    toastPaymentTypeGuid: requiredWhenToast('Payment Type GUID is required'),
    toastScenarioToDiningOptionGuid: toastDictionarySchema,
    toastScenarioToChargeGuid: toastDictionarySchema,
    toastScenarioToRevenueCenterGuid: toastDictionarySchema
});
